'use client';

import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import logSignUpScreenContinueButtonTapped from '@alltrails/amplitude/events/logSignUpScreenContinueButtonTapped';
import Button from '@alltrails/denali/components/Button';
import AppQrCodeModal from '../AppQrCodeModal';
import exploreQrCodeSrc from '../AppQrCodeModal/qrCodes/explore-qr-code.webp';
import styles from './styles/styles.module.scss';

const GetTheAppButton = () => {
  const [showGetTheAppModal, setShowGetTheAppModal] = useState(false);

  return (
    <>
      <Button
        onClick={() => {
          logSignUpScreenContinueButtonTapped({ signup_screen_continue_button_type: 'continue in app' });
          setShowGetTheAppModal(true);
        }}
        size="sm"
        text={<FormattedMessage defaultMessage="Get the app" />}
        variant="accent"
      />
      <AppQrCodeModal
        className={styles.getTheAppModal}
        isOpen={showGetTheAppModal}
        onRequestClose={() => {
          setShowGetTheAppModal(false);
        }}
        qrCode={exploreQrCodeSrc}
        subtitleDesktop={<FormattedMessage defaultMessage="Scan the QR code to open the AllTrails app" />}
        title={<FormattedMessage defaultMessage="Open in the app" />}
      />
    </>
  );
};

export default GetTheAppButton;
